import React, { useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Hero1 from "../components/Hero1";
import Hero2 from "../components/Hero2";
import Hero3 from "../components/Hero3";
import Hero4 from "../components/Hero4";
import Hero5 from "../components/Hero5";
import Footer from "../components/Footer";

function HomePage({
  products,
  searchbarVisible,
  setDrawerOpenCart,
  drawerOpenCart,
  checkedTACC,
  setCheckedTACC,
  checkedGluten,
  setCheckedGluten,
  searchTerm,
  setSearchTerm,
  selectedCategory,
  setSelectedCategory,
  cartItems,
  setCartItems,
  play,
}) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        scrollBehavior: "smooth",
        backgroundColor: "#903AF2", // violeta sólido
      }}
    >
      {/* Sección 1 - Hero1 */}
      <Box sx={{ width: "100%" }}>
        <Hero1 />
      </Box>

      {/* Sección 2 - Hero2 */}
      <Box sx={{ width: "100%" }}>
        <Hero2 />
      </Box>

      {/* Sección 3 - Hero3 */}
      <Box sx={{ width: "100%"}}>
        <Hero3 />
      </Box>

      {/* Sección 4 - Hero4 */}
      <Box sx={{ width: "100%" }}>
        <Hero4 />
      </Box>
      {/* Sección 4 - Hero4 */}
      <Box sx={{ width: "100%" }}>
        <Hero5 />
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
}

export default HomePage;
